<template>
  <md-card>
    <md-card-header>
      <div class="md-layout">
        <div class="md-layout-item md-size-90">
          <h4 class="title">Pricing</h4>
          <p class="category">
            Set the default Pricing for new Departures
          </p>
        </div>
        <div class="md-layout-item md-size-10 text-right"></div>
      </div>
    </md-card-header>
    <md-card-content>
      <div class="md-layout md-alignment-middle-left price-row">
        <div class="md-layout-item md-size-33">
          <md-field class="md-form-group" slot="inputs">
            <md-icon
              ><i class="fas fa-pound-sign text-primary hi-price-icon"></i
            ></md-icon>
            <label>GBP</label>
            <md-input v-model="tour.prices.gbp" type="text"></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-size-33">
          <md-field class="md-form-group" slot="inputs">
            <md-icon
              ><i class="fas fa-euro-sign text-primary hi-price-icon"></i
            ></md-icon>
            <label>EUR</label>
            <md-input v-model="tour.prices.eur" type="text"></md-input>
          </md-field>
        </div>
        <div class="md-layout-item md-size-33">
          <md-field class="md-form-group" slot="inputs">
            <md-icon
              ><i class="fas fa-dollar-sign text-primary hi-price-icon"></i
            ></md-icon>
            <label>USD</label>
            <md-input v-model="tour.prices.usd" type="text"></md-input>
          </md-field>
        </div>
      </div>

      <div class="md-layout md-alignment-middle-left">
        <div class="md-layout-item md-size-50">
          <div class="text-left">
            <md-button
              class="md-raised md-success md-dense mt-4"
              @click.prevent="publishPricing"
              >Publish</md-button
            >
          </div>
        </div>
        <div class="md-layout-item md-size-50">
          <div class="text-right">
            <md-button
              class="md-raised md-success md-dense mt-4"
              @click.prevent="updatePricing"
              >Update</md-button
            >
          </div>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>
<script>
import tourApi from "@/services/api/tour";

export default {
  props: {
    tour: {
      type: Object
    }
  },

  data() {
    return {};
  },

  computed: {},

  methods: {
    updatePricing() {
      tourApi.updatePricing(this.tour).then(response => {
        this.$notify({
          timeout: 2500,
          message: "The Pricing has been updated.",
          icon: "thumb_up",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success"
        });
      });
    },
    publishPricing() {
      tourApi.publishPricing(this.tour).then(response => {
        this.$notify({
          timeout: 2500,
          message: response.message,
          icon: "thumb_up",
          horizontalAlign: "center",
          verticalAlign: "top",
          type: "success"
        });
      });
    }
  },

  mounted() {}
};
</script>
<style lang="scss" scoped>
.price-row {
  margin-bottom: 1rem;
}
</style>
